import { RequestError, } from './RequestError';
/**
 * Recoverable errors.
 *
 * Don't instantiate recoverable errors yourself, they are thrown by the framework as needed.
 */
export class RecoverableApiError extends RequestError {
    static className = 'RecoverableApiError';
    constructor(props) {
        super(props);
    }
}
